export default {
  Calendar: {
    Details: {
      Title: 'Clients',
      Time: 'Time',
      Status: 'Status',
      Break: 'Break',
      BreakDetails: '#{breakCount} × #{breakDuration} minutes',
    },
    Filter: {
      User: {
        ScheduleForThisWeek: 'Have schedule for this week',
      },
      Event: {
        NotConfirmedShift: 'Has not confirmed shift',
        NotClockedIn: 'Has not clocked in',
        NotClockedOut: 'Has not clocked out',
        LateClockin: 'Has clocked in late',
        EarlyClockout: 'Has clocked out early',
        Cancelled: 'Is cancelled',
        Deleted: 'Is deleted',
        Rescheduled: 'Is rescheduled',
      },
    },
  },
};
